jQuery(document).ready(function($) {
    'use strict';

    // Gallery Swiper
    var gallery_swiper = new Swiper('.gallery .swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
    });

    // Hero Swiper
    var fifty_fifty_swiper = new Swiper('.fifty-fifty.swiper', {
        observer: true,
        observeParents: true,
        /*autoplay: {
            delay: 7000,
        },*/
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },
        pagination: {
            el: ".swiper-pagination",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // Guest Reviews Swiper
    var guest_reviews_swiper = new Swiper('.guest-reviews-slider.swiper', {
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: 5000,
        pagination: {
            el: '.guest-reviews-slider .swiper-pagination',
            clickable: true,
        },
    });

    // Offer Swiper
    var offer_swiper = new Swiper('.offer.swiper', {
        slidesPerView: 1.1,
        spaceBetween: 12,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
        breakpoints: {
            768: {
                slidesPerView: 2.25,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3.25,
                spaceBetween: 24,
            },
        }
    });

});
//# sourceMappingURL=swiper-controls.js.map
